import PlayCircleIcon from "@mui/icons-material/PlayCircle";
import IconButton from "@mui/material/IconButton";
import dayjs from "dayjs";
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import React from "react";
import { useFormContext } from "react-hook-form";

import { StartTaskPropInterface } from "./StartTask";

import { CreateTaskInterface } from "@/types/task";

dayjs.extend(utc);
dayjs.extend(timezone);

export const StartTask: React.FC<StartTaskPropInterface> = ({ isLoading }) => {
  const { setValue } = useFormContext<CreateTaskInterface>();
  return (
    <IconButton
      color="primary"
      onClick={() => setValue("startTime", dayjs().tz().format())}
      disabled={isLoading}
      type="submit"
    >
      <PlayCircleIcon sx={{ fontSize: "3rem" }} />
    </IconButton>
  );
};
